export class LinkProtocol {
	public static readonly $type: string = "LinkProtocol";
	public readonly $type: string = LinkProtocol.$type;

	public id?: number;
	public name: string = "";
	public protocol: string = "";
}
